import { faColumns3 } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import { VoxelPopover } from '../../../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../voxel/Popover/VoxelPopoverTrigger';
import KeywordColumnPickerHiddenColumns from './KeywordColumnPickerHiddenColumns';
import KeywordColumnPickerShownColumns from './KeywordColumnPickerShownColumns';
import { KeywordColumnPickerBag } from './useKeywordColumnPicker';

export interface KeywordTableColumnPickerProps {
  keywordColumnPickerBag: KeywordColumnPickerBag;
  project: ProjectGq;
  isProgressPage?: boolean;
}

export const KeywordTableColumnPicker: React.FC<KeywordTableColumnPickerProps> = ({
  project,
  keywordColumnPickerBag,
  isProgressPage,
}) => {
  return (
    <VoxelPopover>
      <VoxelPopoverTrigger enableActive>
        <DataTableToolbarButton tooltip="Edit active columns" iconProp={faColumns3} />
      </VoxelPopoverTrigger>
      <VoxelPopoverContent arrowClasses="fill-voxel-gray-200" initialFocus={-1}>
        <div className="max-h-[300px] lg:max-h-[400px] xl:max-h-[500px] 2xl:max-h-[800px] overflow-y-scroll">
          <KeywordColumnPickerShownColumns
            project={project}
            keywordColumnPickerBag={keywordColumnPickerBag}
            isProgressPage={isProgressPage}
          />
          <KeywordColumnPickerHiddenColumns
            project={project}
            keywordColumnPickerBag={keywordColumnPickerBag}
          />
        </div>
      </VoxelPopoverContent>
    </VoxelPopover>
  );
};

export default KeywordTableColumnPicker;
